function filterSalesReps(ev) {
  const newRegion = ev.target.value;
  const newCountry = ev.target.dataset.region;

  // if the country doesn't match, hide the whole section
  document.querySelectorAll('.rep-contact').forEach((rc) => {
    const thisCountry = rc.dataset.region;

    if (thisCountry !== newCountry) {
      rc.classList.add('hidden');
    } else {
      rc.classList.remove('hidden');
    }
  });

  // loop over all the contact cards and add class to hide
  document.querySelectorAll('.rep-contact-block').forEach((rcb) => {
    const contactRegions = rcb.dataset.region;

    if (contactRegions.indexOf(newRegion) === -1) {
      rcb.classList.add('hidden');
    } else {
      rcb.classList.remove('hidden');
    }
  });
}

domReady(() => {
  document.querySelectorAll('.region-select').forEach((rs) => {
    rs.addEventListener('change', filterSalesReps);
  });
});